export const palette = {
  brand: '#ffdd00',
  neutral1: '#ffffff',
  neutral2: '#e5e5e5',
  neutral3: '#b3b3b3',
  neutral4: '#fafafb',
  passive: '#999999',
  dark: '#2b3034',
  dark2: '#33373b',
  dark3: '#666666',
  controls: '#4c5760',
  error: '#e8124d',
  success: '#8cc50f',
  warning: '#eea600',
}

export const fonts = {
  fontFamilyTitle: "'Flanders Art Sans', 'Open Sans', sans-serif",
  fontFamilyBase: "'Open Sans', sans-serif",
}

export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
}

// padding/margin steps for mobile
export const spacing = {
  0: '0px',
  1: '5px',
  2: '15px',
  3: '20px',
  4: '40px',
}

// padding/margin steps for desktop
export const spacingLarge = {
  0: '0px',
  1: '10px',
  2: '20px',
  3: '40px',
  4: '80px',
}
